import React, {
  createContext,
  PropsWithChildren,
  useEffect,
  useState
} from 'react';

interface LayoutContextInterface {
  columnCount: 2 | 3;
}

export const LayoutContext = createContext<LayoutContextInterface>({
  columnCount: 3
});

export const LayoutContextProvider = ({children}: PropsWithChildren) => {
  const [columnCount, setColumnCount] = useState<2 | 3>(3);

  const handleColumnCount = () => {
    if (window.innerWidth <= 1024) {
      setColumnCount(2);
    } else {
      setColumnCount(3);
    }
  };

  useEffect(() => {
    handleColumnCount();

    window.addEventListener('resize', handleColumnCount);
    return () => {
      window.removeEventListener('resize', handleColumnCount);
    };
  }, []);

  return (
    <LayoutContext.Provider
      value={{
        columnCount
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};
